import { fetchResponses, parseResponses } from './responses'

export async function fetchFormResponses (form) {
  const responses = await fetchResponses(form.id)

  return parseResponses(responses, form)
}

export { fetchForm } from './forms'
